<mat-form-field fxFlex="100">
  <mat-placeholder>Type</mat-placeholder>
  <input matInput value="{{issueType.name}}" disabled/>
</mat-form-field>
